import {useState, useEffect} from 'react';
import NormalBtn from '../StockItems/NormalBtn';
import * as ServerComms from '../utilities/ServerComms';
import PreviousCodes from './PreviousCodes';

function App(props) {

  var programSetID = props.programSetID;
  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var setSelectedStep = props.setSelectedStep;
  var currentList = props.currentList;
  var addToExtraScreen = props.addToExtraScreen;
  var clickBack = props.clickBack;

  var feSet = currentList.fe;
  var nosFe = Object.keys(feSet).length;

  var creditsRequired = 10 * nosFe; 
  var nosCredits = props.nosCredits;

  const [isSubmitted, setIsSubmitted] = useState(-1);
  const [loaded, setLoaded] = useState(false);
  const [walletConnectProjectID, setWalletConnectProjectID] = useState('');
  const [walletConnectProgramName, setWalletConnectProgramName] = useState('');

  var postWalletFunction = function(responseIn){
    setWalletConnectProjectID(responseIn.v[0].v);
    setWalletConnectProgramName(responseIn.v[1].v);
    setLoaded(true);
  }

  function getWalletConnectInfo(){

    if (signKey){
      var passObject = {
          u:'getWalletConnectInfo',
          sessionID,
          userID,
          signKey,
          programSetID,
        };

      ServerComms.fetchSomething(passObject, postWalletFunction, failFunction, []);
    }
  }


  var failFunction = function(){
    setIsSubmitted(-1);
    console.log("Fail");
  }


  function getCode(){
    if (creditsRequired > nosCredits){
      addToExtraScreen({t:'credits',v:creditsRequired});
    }else{
      if (isSubmitted === -1){

        var postFunction = function(responseIn){
          if (responseIn.t === 'atom'){
            window.alert('Insufficient credits');
          }else{
            setSelectedStep(['de', 'coded', responseIn.v]);
          }
          setIsSubmitted(-1);
        }


        var passObject = {
            u:'getCode',
            programSetID,
            sessionID,
            signKey,
            userID,
            whichPath:'C',
          };
        setIsSubmitted(0);
        ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
      }

    }
  }

  useEffect(()=>{
    getWalletConnectInfo();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps


  if (!loaded){
    return <div>Loading...</div>
  }
//
  var codePart;
//  
  var walletConnectText;
  if (walletConnectProjectID === '' || walletConnectProgramName === ''){
    walletConnectText = 'To generate your code, first get a wallet connect Project ID';
  }else{
    walletConnectText = 'Update your wallet connect ID';

    var title = 'Get Code (' + creditsRequired + ' credits)';
    if (isSubmitted !== -1){
      title = 'Generating...'
    }

    codePart = <NormalBtn onClick={getCode} isHighlighted={true} title={title}/>
  }
//


    var existingProjId = walletConnectProjectID;
    if (!existingProjId){
      existingProjId = '[Empty]';
    }

    var existingProjName = walletConnectProgramName;
    if (!existingProjName){
      existingProjName = '[Empty]';
    }

    function changeProjectId(e){
      var projectId = window.prompt('Please key in the wallet connect project Id', walletConnectProjectID);
      if (projectId){

        if (signKey){
          var passObject = {
              u:'updateWalletConnectProjectId',
              sessionID,
              projectId,
              userID,
              signKey,
              programSetID,
            };

          ServerComms.fetchSomething(passObject, postWalletFunction, failFunction, []);
        }

      }
    }

    function changeProjectName(e){
      var projectName = window.prompt('Please key in the wallet connect project name', walletConnectProgramName);
      if (projectName){

        if (signKey){
          var passObject = {
              u:'updateWalletConnectProjectName',
              sessionID,
              projectName,
              userID,
              signKey,
              programSetID,
            };

          ServerComms.fetchSomething(passObject, postWalletFunction, failFunction, []);
        }

      }
    }


  var previousPiece = <PreviousCodes programSetID={programSetID} userID={userID} sessionID={sessionID} signKey={signKey} setSelectedStep={setSelectedStep} />

//

//
     return <div className="container py-5"><div className="row mb-4">
      <div className="col-lg-10 mx-auto text-center">
        <br/>
        {codePart}<NormalBtn onClick={clickBack} title='Back'/>
        <br/>
        <br/>
        <div>{walletConnectText} by clicking <span onClick={function(e){window.open('https://cloud.walletconnect.com/sign-in')}} style={{cursor:'pointer', textDecoration:'underline'}}>here</span>. You will get one by creating a project and adding your dApp url.<p/>
        <div>Project ID : <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={changeProjectId}>{existingProjId}</span></div><p/>
        <div>Project Name : <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={changeProjectName}>{existingProjName}</span></div>
        </div>
        <br/>
        <p className="lead mb-0">Cues has made every attempt to ensure the accuracy and reliability of the code generated on this website. However, the code is provided 'as is' without warranty of any kind. Cues does not accept any responsibility or liability for the accuracy, content, completeness, legality, or reliability of the code provided by this website.<br/><br/>No warranties, promises and/or representations of any kind, expressed or implied, are given as to the nature, standard, usefulness, correctness, accuracy or otherwise of the code provided in this website nor to the suitability or otherwise of the code provided to your particular circumstances.<br/><br/>We cannot and will not guarantee that the code provided is free from computer viruses or anything else that has destructive properties.<br/><br/>We shall not be liable for any loss or damage of whatever nature (direct, indirect, consequential, or other) whether arising in contract, tort or otherwise, which may arise as a result of your use of (or inability to use) this website, or from your use of (or failure to use) the code provided by or information on this site.<br/><br/>If the code provided by this website does not work, kindly let us know by contacting me via Telegram @cuessg and we will be happy to re-credit back the credits used to generate the code.</p>
      </div></div>
      {previousPiece}

      </div>

  

}

export default App;
